// extracted by mini-css-extract-plugin
var _1 = "spXtj";
export { _1 as "base" }
